<template>
    <transition name="slide">
        <div :class="classes"
             style="right: 25px; bottom: 25px; z-index: 999999;"
             role="alert"
             v-show="show"
             v-text="body">
        </div>
    </transition>
</template>

<script>
    import {EventBus} from "../../hermeneus.eventbus/eventbus";

    export default {
        props: ['message'],

        data () {
            return {
                body: this.message,
                level: 'success',
                show: false
            }
        },

        computed: {
            classes () {
                let defaults = ['fixed', 'p4', 'bg-white', 'box-shadow-wide', 'rounded'];

                if (this.level === 'success') defaults.push('color-white', 'bg-green', 'border-green');
                if (this.level === 'warning') defaults.push(/*'color-yellow',*/ 'border-yellow');
                if (this.level === 'danger') defaults.push('color-white', 'bg-red', 'border-red');

                return defaults;
            },


        },

        created () {
            if (this.message) {
                setTimeout(() => {
                    this.flash();
                }, 1000);
            }

            EventBus.$on(
                'flash', data => this.flash(data)
            );
        },

        methods: {
            flash (data) {
                if (data) {
                    this.body = data.message;
                    this.level = data.level;
                }

                this.show = true;

                this.hide();
            },

            hide () {
                setTimeout(() => {
                    this.show = false;
                }, 5000);
            }
        }
    };
</script>
<style lang="sass" scoped>
    .rounded
        border-radius: 2px

    .bg-white
        background: #fff

    .bg-green
        background: #5cb85c

    .bg-yellow
        background: #f0ad4e

    .bg-red
        background: #d9534f

    .border-green
        border: 1px solid #328018

    .border-yellow
        border-top: 4px solid #f0ad4e

    .border-red
        border: 1px solid #B22E2F

    .color-green
        color: #328018

    .color-yellow
        color: #f0ad4e

    .color-red
        color: #d9534f

    .color-white
        color: #fff

    .enter
        transform: translateX(100%)

    .enter-to
        transform: translateX(0)

    .slide-enter-active
        position: absolute

    .leave
        transform: translateX(0)

    .leave-to
        transform: translateX(-100%)

    .slide-enter-active,
    .slide-leave-active
        transition: all 750ms ease-in-out


</style>